// extracted by mini-css-extract-plugin
export default {"page_controls":"page_page_controls__r2aMg","page_control":"page_page_control__K1a4O"};